const reqSvgs = require.context( '../images', true, /\.svg$/ )

export default reqSvgs.keys().reduce((carry, path) => {
  carry[path.replace('./', '')] = reqSvgs(path);
  return carry;
}, {});
